var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophicAnthropogenic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.083 13.5S0 13.5 0 12.417c0-1.084 1.083-4.334 6.5-4.334s6.5 3.25 6.5 4.334c0 1.083-1.083 1.083-1.083 1.083H1.083ZM6.5 7a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z",
    fill: "#303752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophicAnthropogenic);
export default __webpack_public_path__ + "static/media/trophic-anthropogenic.aa869d41cfd280129b1bc228afa6d092.svg";
export { ForwardRef as ReactComponent };